import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-900 px-4 pb-28 pt-8 text-center text-white/50" data-id="element-105" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-2xl border-t border-white/10 pt-7" data-id="element-106" data-mp="3gg1025qei1yp">
        <div className="flex items-center justify-center gap-2" data-id="element-107" data-mp="32oni2w855c5s">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white/10 font-display text-base font-bold text-gold" data-id="element-108" data-mp="32m1et8sa9itd">
            K
          </span>
          <span className="font-display text-base font-bold text-white/80" data-id="element-109" data-mp="3ufjyu7xbo0yc">Dra. Karito</span>
        </div>
        <p className="mt-4 text-[12px] leading-relaxed" data-id="element-110" data-mp="37xwqjq946jl">
          Kit Clínico para el Manejo de la Obesidad · Material educativo dirigido a profesionales de
          la salud. No sustituye el juicio clínico ni las guías locales de cada país.
        </p>
        <p className="mt-3 text-[12px]" data-id="element-111" data-mp="29yxdpewb9omv">
          © {new Date().getFullYear()} Dra. Karito. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}